import { SubscriptionApi } from './subscription.api';

const subscriptionApi = new SubscriptionApi();

export { subscriptionApi };
